import { configureStore } from "@reduxjs/toolkit";
import globalsReducer from "./globalsSlice";
import panelPositionsReducer from "./panelPositionsSlice"; 
import dropDownReducer from "./dropDownSlice";

const globalsStore = configureStore({
   reducer: {
      globals: globalsReducer,
      panelPositions: panelPositionsReducer,
      dropDown: dropDownReducer, 
   },
});

export default globalsStore;
